<mat-toolbar>
  <div fxFlex fxFill fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="row">
      <button mat-icon-button class="navbar-toggle-button" (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
        <mat-icon class="secondary-text">menu</mat-icon>
      </button>
      <div class="toolbar-separator" *ngIf="!hiddenNavbar && !rightNavbar" fxHide.gt-md></div>
      <div fxLayout="row" fxLayoutAlign="start center" *ngIf="horizontalNavbar">
        <div class="logo ml-16">
          <img class="logo-icon" src="assets/images/logos/fuse.svg">
        </div>
      </div>
      <div fxLayoutAlign="flex-start center" style="width: 100%" fxHide fxShow.gt-xs>
        <div class="logo ml-4 finance-exhange-column-custom">
          <img class="logo ml-4 finance-exhange-logo-custom" src="assets/finance-exhange-logo.png">
          <span class="dtext2">&trade;</span>
        </div>
      </div>


    </div>


    <div>
      <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="12px">
        <div class="px-2 px-md-4 styls"
          *ngIf="!currentUser?.switchUserprofile && [8,9, 10].indexOf(currentUser?.UserDetails?.UserTypeID) != -1">
          <!-- <mat-slide-toggle class="custom-slide-toggle" style="padding-right: 0px !important;font-size: 16px;color: white;"
            (click)="changeDashboard()" [checked]="checkedNewDashboard">New Dashboard</mat-slide-toggle> -->
        </div>
        <div class="px-2 px-md-4 styls">
          <mat-nav-list>
            <a routerLink="/apps/dashboard">
              <span class="material-icons icodsign">dashboard</span>
              <span class="h4 dtext">Dashboard</span>
            </a>
          </mat-nav-list>
        </div>
        <div class="px-2 px-md-4 styls">
          <mat-nav-list>
            <a routerLink="/apps/deals">
              <span class="material-icons icodsign">local_offer</span>
              <span class="h4 dtext">Individual Deals</span>
            </a>
          </mat-nav-list>
        </div>
        <div class="px-2 px-md-4 styls">
          <mat-nav-list>
            <a routerLink="/apps/deal-group">
              <span class="material-icons icodsign">local_offer</span>
              <span class="h4 dtext">Deal Group</span>
            </a>
          </mat-nav-list>
        </div>
        <div class="px-2 px-md-4 styls">
          <mat-nav-list>
            <a routerLink="/apps/deal-pools">
              <span class="material-icons icodsign">
                poll
              </span>
              <span class="h4 dtext">
                Deal Pools
              </span>
            </a>
          </mat-nav-list>
        </div>
        <button style="padding: 0px;" mat-button [matMenuTriggerFor]="menu2" class="user-button"
          *ngIf="currentUser && currentUser.UserDetails.UserTypeID != 5">
          <div fxLayout="row" fxLayoutAlign="center center">
            <span class="material-icons icodsign" style="font-size: 1em; margin-top: 7px;">date_range</span>
            <span class="h4 mat-button"
              style="color:#fff; margin-top: 6px; font-size: 16px; padding: 0px;">Reports</span>
            <mat-icon class="s-16" fxHide.xs style="color: #fff; margin-top: 8px;">keyboard_arrow_down
            </mat-icon>
          </div>
        </button>
        <mat-menu #menu2="matMenu" [overlapTrigger]="false">
          <button mat-menu-item routerLink="/apps/report">
            <span class="material-icons icodsign">
              {{ (currentUser == null) ||!currentUser.switchUserprofile &&
              [8,9,10].indexOf(currentUser.UserDetails.UserTypeID) != -1 ? 'date_range':
              ''}}
            </span>
            <span class="h4 dtext"> {{ (currentUser == null) ||!currentUser.switchUserprofile &&
              [8,9,10].indexOf(currentUser.UserDetails.UserTypeID) != -1 ? 'Individual Deal Reports':
              ''}}
            </span>
          </button>
          <button mat-menu-item routerLink="/apps/deal-pool-report">
            <span class="material-icons icodsign">
              {{ (currentUser == null) ||!currentUser.switchUserprofile &&
              [8,9,10].indexOf(currentUser.UserDetails.UserTypeID) != -1 ? 'date_range':
              ''}}
            </span>
            <span class="h4 dtext"> {{ (currentUser == null) ||!currentUser.switchUserprofile &&
              [8,9,10].indexOf(currentUser.UserDetails.UserTypeID) != -1 ? 'Deal Pool Reports':
              ''}}
            </span>
          </button>
        </mat-menu>
        <div class="px-2 px-md-4 styls">
          <mat-nav-list>
            <a routerLink="/apps/contacts">
              <span class="material-icons icodsign">contacts</span>

              <span class="h4 dtext">{{ (currentUser == null) || !currentUser.switchUserprofile &&
                [8,9,10].indexOf(currentUser.UserDetails.UserTypeID) != -1 ? 'Buyers' :
                'Sellers'}}</span>
            </a>
          </mat-nav-list>
        </div>
        <div class="px-2 px-md-4 styls">
          <mat-nav-list>
            <a routerLink="/apps/chats" (click)="markMessagesRead()">
              <div style="display: flex;align-items: center;padding-right: 10px;">
                <span style="padding-right: 3px;font-size: 20px;color: white;" class="material-symbols-outlined">
                  message
                </span>
                <span id="badge-documents" style="padding-top: 5px; " class="h4 dtext custom-badge"
                  matBadgeColor="accent" matBadge="{{unreadMessagesCount}}" matBadgeSize="medium"
                  matBadgePosition="above after">Messages</span>
              </div>
            </a>
          </mat-nav-list>
        </div>
        <div class="px-2 px-md-4 styls">
          <mat-nav-list>
            <a routerLink="/apps/documentsigned">
              <div style="display: flex;align-items: center;padding-right: 10px;">
                <span style="padding-right: 3px;font-size: 20px;color: white;" class="material-symbols-outlined">
                  edit_document
                </span>
                <span id="badge-documents" style="padding-top: 5px; " class="h4 dtext custom-badge"
                  matBadgeColor="accent" matBadge="{{counterDocument}}" matBadgeSize="medium"
                  matBadgePosition="above after">Document
                  Inbox</span>
              </div>
            </a>
          </mat-nav-list>
        </div>
        <div class="px-2 px-md-4 styls attention-connectifi-button">
          <mat-nav-list>
            <a routerLink="/apps/connectifi">
              <div style="display: flex;align-items: center;padding-right: 10px;">
                <mat-icon svgIcon="user-connectifi" class="icon-size"></mat-icon>
                <span
                  *ngIf="!currentUser?.switchUserprofile && [8,9, 10].indexOf(currentUser?.UserDetails?.UserTypeID) != -1"
                  id="badge-documents" style="" class="h4 dtext custom-badge" matBadgeColor="accent"
                  matBadge="{{counterConnectifi}}" matBadgeSize="medium"
                  matBadgePosition="above after">Connectifi</span>
                <span *ngIf="(currentUser?.UserDetails?.UserTypeID === 5 || currentUser?.UserDetails?.UserTypeID === 11) || (currentUser?.switchUserprofile &&
                [5, 9, 11].indexOf(currentUser?.UserDetails?.UserTypeID) != -1)" id="badge-documents"
                  style="padding-top: 5px; " class="h4 dtext custom-badge" matBadgeColor="accent"
                  matBadge="{{counterConnectifi}}" matBadgeSize="medium"
                  matBadgePosition="above after">Connectifi</span>
              </div>
            </a>
          </mat-nav-list>
        </div>

        <div class="px-2 px-md-4 styls docufi-button"
          style="background: linear-gradient(135deg, #0f5f1f, #1e6b33, #28a745, #34d058); border-radius: 20px; box-shadow: 0 4px 15px rgba(40, 167, 69, 0.4), 0 0 20px rgba(40, 167, 69, 0.2); border: 2px solid rgba(255,255,255,0.2); position: relative; transform: translateY(0); transition: all 0.3s ease; animation: pulse-glow 3s infinite, breathing 2.5s ease-in-out infinite; padding: 2px 6px 4px 6px; margin-left: 5px;">
          <span class="material-icons"
            style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); font-size: 40px; color: rgba(255,255,255,0.15); z-index: 1;">folder_open</span>
          <div
            style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: linear-gradient(45deg, rgba(255,255,255,0.1), transparent, rgba(255,255,255,0.05)); border-radius: 20px; z-index: 1;">
          </div>
          <mat-nav-list style="position: relative; z-index: 3;">
            <a routerLink="/apps/docufi" class="docufi-link" style="text-decoration: none;">
              <div style="display: flex; align-items: center; padding-right: 10px;">
                <span
                  style="padding-right: 3px; font-size: 20px; color: white; text-shadow: 0 2px 4px rgba(0,0,0,0.3); filter: drop-shadow(0 0 3px rgba(255,255,255,0.5));"
                  class="material-symbols-outlined">
                  folder_shared
                </span>
                <span id="badge-documents" style="padding-top: 5px; font-weight: 600; position: relative;"
                  class="h4 dtext custom-badge">
                  Docufi
                  <span class="new-badge"
                    style="position: absolute; top: -8px; right: -15px; background: linear-gradient(45deg, #ff6b35, #ff8c42); color: white; font-size: 10px; font-weight: 700; padding: 2px 6px; border-radius: 8px; border: 1px solid rgba(255,255,255,0.3); box-shadow: 0 2px 4px rgba(0,0,0,0.3); animation: badge-pulse 2s ease-in-out infinite; letter-spacing: 0.5px;">NEW</span>
                </span>
              </div>
            </a>
          </mat-nav-list>
        </div>

        <!-- More items... -->
      </div>
    </div>
    <div class="toolbar-mobile-responsive" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">
      <div class="px-2 px-md-4 styls" style="" *ngIf="currentUser && currentUser.UserDetails.UserTypeID == 9">
        <mat-slide-toggle style="" class="custom-slide-toggle" [checked]="currentUser.switchUserprofile?true:false"
          (change)="switchProfile($event)">Switch to {{ (currentUser == null) ||
          !currentUser.switchUserprofile &&
          [8,9,10].indexOf(currentUser.UserDetails.UserTypeID) != -1 ? 'Buyer' :
          'Seller'}}</mat-slide-toggle>
      </div>
      <div class="notification-wrapper px-2 px-md-4 styls">
        <a matTooltip="NOTIFICATIONS" class="notification-btn" (click)="markNotificationsRead('general')">
          <span class="material-icons icondsign" matBadgeColor="warn" matBadge="{{unreadNotificationCount}}"
            matBadgeSize="medium" matBadgePosition="above after">notifications_active</span>
        </a>
        <div *ngIf="showNotification" class="notification-content" (clickOutside)="openNotification(false)"
          [exclude]="'.notification-btn'">
          <div class="notification-header">
            <h6> Notifications</h6>
          </div>
          <div class="notification-content-body">
            <mat-list>
              <mat-list-item class="mat-list-hovr" *ngFor="let Notification of unreadNotifications">
                <a (click)="onNotificationClick(Notification)" class="notification-list" style="cursor: pointer;">
                  <span>{{ getNotificationTitle(Notification) }}</span>
                </a>
              </mat-list-item>
            </mat-list>
          </div>
        </div>
      </div>

      <div class="update-wrapper px-2 px-md-4 styls">
        <a matTooltip="UPDATES" class="update-btn" (click)="markUpdatesRead()">
          <span class="material-icons icondsign" matBadgeColor="accent" matBadge="{{unreadUpdatesCount}}"
            matBadgeSize="medium" matBadgePosition="above after"><span class="material-symbols-outlined">
              new_releases
            </span></span>
        </a>
        <div *ngIf="showUpdates" class="update-content" (clickOutside)="openUpdates(false)" [exclude]="'.update-btn'">
          <div class="update-header">
            <h6> Updates</h6>
          </div>
          <div class="update-content-body">
            <mat-list>
              <mat-list-item class="mat-list-hovr" *ngFor="let Update of unreadUpdates">
                <a href="{{Update.link}}" class="notification-list" target="_blank">
                  <span> {{Update.Title}} </span>
                </a>
              </mat-list-item>
            </mat-list>
          </div>
        </div>
      </div>

      <button mat-button [matMenuTriggerFor]="menu" class="user-button">
        <div fxLayout="row" fxLayoutAlign="center center">
          <ng-container *ngIf="(currentUser$ | async);else defaultUserAvatar">
            <img class="avatar mr-0 mr-sm-2" src="{{IMAGE_PATH + (currentUser$ | async).UserDetails.ProfilePicture}}"
              alt="User Avatar" *ngIf="(currentUser$ | async).UserDetails.ProfilePicture;else defaultUserAvatar">
          </ng-container>
          <ng-template #defaultUserAvatar>
            <div class="swatch mr-0 mr-sm-2" [ngStyle]="{'background-color':getColor(0)}"
              *ngIf="(currentUser$ | async)">
              {{getInitials((currentUser$ | async).UserDetails.FirstName)}}
            </div>
          </ng-template>
          <span class="username mr-12" fxHide fxShow.gt-sm>{{UserName}}</span>
          <span class="h4 mat-button" style="color:#fff; margin-top: 10px;">My Account</span>
          <mat-icon class="s-16" fxHide.xs style="color: #fff; margin-top: 10px;">keyboard_arrow_down
          </mat-icon>
        </div>
      </button>
      <mat-menu #menu="matMenu" [overlapTrigger]="false">
        <button mat-menu-item (click)="openSubDialog()">
          <span class="material-icons">perm_identity</span>
          <span>
            Change Password
          </span>
        </button>
        <button mat-menu-item routerLink="/apps/my-profile">
          <span class="material-icons">account_circle</span>
          <span>
            My Profile
          </span>
        </button>
        <button mat-menu-item routerLink="/apps/company-profile">
          <span class="material-icons">business</span>
          <span>
            Company Profile
          </span>
        </button>
        <button mat-menu-item routerLink="/apps/app-user-vault">
          <span class="material-icons">folder</span>
          <span>
            My Documents
          </span>
        </button>
        <button mat-menu-item routerLink="/apps/app-company-vault">
          <span class="material-icons">folder_shared</span>
          <span>
            Company Documents
          </span>
        </button>
        <button mat-menu-item *ngIf="subdomain == 'cp'" (click)="backToAdmin()">
          <span class="material-icons">business</span>
          <span>
            Back To Admin
          </span>
        </button>
        <button mat-menu-item (click)="logout()">
          <span class="material-icons">exit_to_app</span>
          <span>
            Logout
          </span>
        </button>
      </mat-menu>
    </div>
  </div>
</mat-toolbar>

<button *ngIf="COUNTRY === 'CAN'" class="btn-calculator" mat-fab aria-label="Calculator" (click)="openCalculator()">
  <!-- <mat-icon svgIcon="calculator" class="icon-size"></mat-icon> -->
  <img class="center-flags" src="./assets/icons/ion_calculator-outline.svg" alt="US Flag">
</button>
<div class="calc-container" *ngIf="visibleCalculator && COUNTRY === 'CAN'"
  [ngClass]="viewCalculator ? 'visible-calculator' : 'not-visible-calculator'">
  <div class="title-container">
    <div class="align-left">
      <button class="close-button" (click)="openCalculator()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <span class="name-calc">Convert USD to CAD or CAD to USD</span>
  </div>
  <div *ngIf="COUNTRY === 'CAN'" class="calc-sub-container padding-calc">
    <mat-form-field appearance="outline">
      <input matInput type="number" class="calc-sub-right-align" [ngModel]="values.usd"
        (ngModelChange)="usdToCad($event)">
      <span matSuffix>USD <img class="prefix-flags" src="./assets/footer/us.png" alt="US Flag"></span>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <input matInput type="number" class="calc-sub-right-align" [ngModel]="values.cad"
        (ngModelChange)="cadtoUsd($event)">
      <span matSuffix>CAD <img class="prefix-flags" src="./assets/footer/canada.png" alt="US Flag"></span>
    </mat-form-field>
  </div>
  <div class="convert-value">1 USD = 1.34645 CAD</div>
</div>

<iframe name="iframe_a" width="100%" *ngIf="isshow"></iframe>